import { render } from "./CreateClientView.vue?vue&type=template&id=73015987"
import script from "./CreateClientView.vue?vue&type=script&lang=js"
export * from "./CreateClientView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__